import React, { useEffect } from "react";
import './education.scss';
import ied from './../../image/ied.webp';
import bocconi from './../../image/bocconi.png';
import { Link } from "react-router-dom";

const Education: React.FC = () => {
  

  return (
    <>
      <section className="education container">
        <div className="wrapper">
          <h2>Education</h2>
          <div className="schools-container">
            <div className="school">
              <div className="img-wrapper">
                <img src={ied} alt="" />
              </div>
              <h3>Media Design</h3>
              <h4>IED - Milan</h4>
              <h5>2020-2023</h5>
            </div>
            <div className="school">
              <div className="img-wrapper">
               <img src={bocconi} alt="" />
              </div>
              <h3>Law</h3>
              <h4>Bocconi University</h4>
              <h5>2017-2020</h5>
            </div>
          </div>
        </div>
      </section>
      
    </>
  );
};

export default Education;
